import moment from 'moment';

import { FillLevelMeasurements, FillLevelType } from '@/generated/fleetAggregationServiceTypes';

export const ENGINE_OIL_OUTDATED_HOURS = 24;
export const ENGINE_OIL_STATE_OK = 'ok';
export const ENGINE_OIL_STATE_LOW = 'low';
export const ENGINE_OIL_STATE_LOW_V2 = 'low_v2';
export const ENGINE_OIL_SPN_HOURS = 24;
const ENGINE_OIL_SIGNAL_DID = 'did';
export const ENGINE_OIL_SENSOR_SIGNAL_V2 = 'sensor_signal_v2';
export const ENGINE_OIL_SENSOR_SIGNAL = 'sensor_signal';
export const ENGINE_OIL_V2_FILL_TYPE = 'engine_oil_v2';
export const ENGINE_OIL_FILL_TYPE = 'engine_oil';

export const isEngineOilOutdated = (timestamp: string | undefined, hoursToBeOutdated: number = ENGINE_OIL_OUTDATED_HOURS) => moment().diff(timestamp, 'hours') > hoursToBeOutdated;

export const isEngineOilDid = (signal: string | undefined) => signal === ENGINE_OIL_SIGNAL_DID;
export const isEngineOilSensorSignalV2 = (signal: string | undefined) => signal === ENGINE_OIL_SENSOR_SIGNAL_V2;

export const isEngineOilTypeDid = (type?: string) => type === FillLevelType.EngineOilDid;
export const isEngineOilTypeV2 = (type?: string) => type === FillLevelType.EngineOilV2;

export const filterEngineOilSensorSignalFillLevels = (fillLevels: FillLevelMeasurements[]) =>
    fillLevels.some((item) => isEngineOilSensorSignalV2(item.signal))
        ? fillLevels.find((fillLevel) => fillLevel.signal === ENGINE_OIL_SENSOR_SIGNAL_V2 && fillLevel.type === ENGINE_OIL_V2_FILL_TYPE)
        : fillLevels.find((fillLevel) => fillLevel.signal === ENGINE_OIL_SENSOR_SIGNAL && fillLevel.type === ENGINE_OIL_FILL_TYPE);
